<template>
  <l-layout :layout="['xs12']">
    <l-data-table
      :get-data-func="getBachelors"
      :headers="headers"
      :must-sort="false"
      @click:row="goDetails($event.item)"
      clickable
      item-key="code"
      search-text="搜索姓名"
      title-text="本科生列表"
      :filter-items="filterItems"
    ></l-data-table>
  </l-layout>
</template>

<script>
export default {
  name: 'BachelorList',
  data () {
    return {
      headers: [
        {text: '姓名', value: 'name', align: 'left', placeholder: 'N/A', sortable: false},
        {text: '学号', value: 'code', align: 'right', placeholder: 'N/A', sortable: false},
        {text: '学院', value: 'orgName', align: 'right', placeholder: 'N/A', sortable: false},
        {text: '专业', value: 'majorName', align: 'right', placeholder: 'N/A', sortable: false},
        {text: '状态', value: 'statusName', align: 'right', placeholder: 'N/A', sortable: false},
        {text: '更新时间', value: 'updateTime', align: 'right', placeholder: 'N/A', sortable: false},
      ],
      filterItems:[
        {
          prependIcon: '$vuetify.icons.person',
          key: 'loginId',
          value: '',
          label: '教工号',
          type: 'input',
          layout: ['xs12', 'sm4'],
        },
      ],
    }
  },
  methods: {
    async getBachelors ({pagination, search,filterItems}) {
      return this.$store.dispatch('mva/getBachelors', {
        pagination,
        search: {name: {keyword: search}},
        filterItems
      })
    },
    goDetails (item, force = false) {
      let selectionString = document.getSelection().toString()
      if (!selectionString || force) {
        this.$router.push({
          name: 'BachelorDetails',
          params: {name: item.name},
          query: {code: item.code}
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
